/**************************************************
 * Nombre:       Contactanos_Mapa
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";

const Contactanos_Mapa = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1532.9673519852959!2d-77.63907139806383!3d0.8269053141669606!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e296bbaf51e826b%3A0xcf858916c3f66c8b!2sColegio%20Mixto%20San%20Felipe%20Neri!5e0!3m2!1ses!2sco!4v1779639559163!5m2!1ses!2sco"
                width={'100%'} height="450" style={{border: 0, filter: 'grayscale(100%)'}} allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"></iframe>

        </Grid>


    )

}
export default Contactanos_Mapa  